module.exports = __webpack_public_path__ + "static/media/Icon-App-1024.82661d30.png";